export const DUCK_CARD_TYPES = {
    WATER: {
        id: "WATER",
        type: "water",
        team: "none",
        countInDeck: 5,
        colorHex: "#64C8FF"
    },
    DUCK_RED: {
        id: "DUCK_RED",
        type: "duck",
        team: "RED",
        countInDeck: 5,
        colorHex: "#CC2233"
    },
    DUCK_BLUE: {
        id: "DUCK_BLUE",
        type: "duck",
        team: "BLUE",
        countInDeck: 5,
        colorHex: "#3399FF"
    },
    DUCK_GREEN: {
        id: "DUCK_GREEN",
        type: "duck",
        team: "GREEN",
        countInDeck: 5,
        colorHex: "#32C832"
    },
    DUCK_YELLOW: {
        id: "DUCK_YELLOW",
        type: "duck",
        team: "YELLOW",
        countInDeck: 5,
        colorHex: "#FFD700"
    },
    DUCK_PURPLE: {
        id: "DUCK_PURPLE",
        type: "duck",
        team: "PURPLE",
        countInDeck: 5,
        colorHex: "#B432FF"
    },
    DUCK_ORANGE: {
        id: "DUCK_ORANGE",
        type: "duck",
        team: "ORANGE",
        countInDeck: 5,
        colorHex: "#FFAA00"
    }
};